import type { TrackEventRequest } from "@b2bportal/event-tracking-api";
import { trackingBatcher } from "./TrackingBatcher";

export type HTSTransformedEvent = {
  name: string;
  properties?: Record<string, unknown>;
  encryptedProperties?: string[];
};

export const usePublishHTSEvent = () => {
  return publishHTSEvent;
};

export const publishHTSEvent = async (
  event: HTSTransformedEvent
): Promise<boolean> => {
  const request: TrackEventRequest = {
    eventName: event.name,
    properties: event.properties,
    encryptedProperties: event.encryptedProperties,
  };

  const req: TrackEventRequest = request.eventName.startsWith("w1_")
    ? request
    : {
        ...request,
        eventName: `w1_${request.eventName}`,
      };

  if (
    (!import.meta.env.PROD || import.meta.env.VITE_DEVTOOL === "true") &&
    typeof window !== "undefined"
  ) {
    const buf = ((window as any).__DEVTOOL_TRACKING_BUFFER__ ??= []);
    const entry = {
      eventName: req.eventName,
      properties: req.properties,
      source: "publishHTSEvent",
      timestamp: Date.now(),
      status: "pending" as string,
    };
    buf.push(entry);
    if (buf.length > 500) buf.splice(0, buf.length - 500);

    return trackingBatcher.enqueue(req, undefined, (status) => {
      entry.status = status;
    });
  }

  return trackingBatcher.enqueue(req);
};
